const r = {
  primary: { backgroundColor: "button-primary-bg_hover" },
  secondary: { backgroundColor: "button-secondary-bg_hover" },
  tertiary: {
    backgroundColor: "button-tertiary-bg_hover",
    borderColor: "button-tertiary-border_hover"
  },
  quaternary: { backgroundColor: "button-quaternary-bg_hover" }
}, o = {
  primary: { backgroundColor: "button-primary-bg_subtle" },
  secondary: { backgroundColor: "button-secondary-brand-bg_subtle" },
  tertiary: {
    backgroundColor: "button-tertiary-bg_subtle",
    borderColor: "button-tertiary-border"
  },
  quaternary: { backgroundColor: "transparent" }
};
export {
  o as active,
  r as hover
};
